export default __webpack_public_path__ + "locales/hy-AM/EmptyTrashDialog.json?hash=f633906bf7d233a9768e328d992a50bf";